import { lazyRetry } from '@cast/utils';

import { SETTINGS_ROUTE_SEGMENTS } from '@oneclick/constants/navigation';

import type { OneClickNavItem } from '@oneclick/routing';

const SystemController = lazyRetry(
  () => import('@cast/split-me/pages/organization/management/SystemController')
);

const ClusterHibernationPage = lazyRetry(
  () => import('@cast/split-me/pages/settings/ClusterHibernationPage')
);

const ScheduledRebalancingPage = lazyRetry(
  () => import('@cast/split-me/pages/settings/ScheduledRebalancingPage')
);

const CommitmentsController = lazyRetry(
  () => import('@cast/split-me/pages/commitments/CommitmentsController')
);

const OrganizationDetailsPage = lazyRetry(() =>
  import(
    '@cast/split-me/pages/organization/management/OrganizationDetailsPage'
  ).then((m) => ({ default: m.OrganizationDetailsPage }))
);

const BillingPlatformUsagePage = lazyRetry(() =>
  import(
    '@cast/split-me/pages/organization/management/BillingPlatformUsagePage'
  ).then((m) => ({ default: m.BillingPlatformUsagePage }))
);

const ReportingPlatformUsagePage = lazyRetry(() =>
  import(
    '@cast/split-me/pages/organization/management/ReportingPlatformUsagePage'
  ).then((m) => ({ default: m.ReportingPlatformUsagePage }))
);

const ReportingPlansPage = lazyRetry(() =>
  import(
    '@cast/split-me/pages/organization/management/ReportingPlansPage'
  ).then((m) => ({ default: m.ReportingPlansPage }))
);

const PlatformUsageDetailPage = lazyRetry(() =>
  import(
    '@cast/split-me/pages/organization/management/PlatformUsageDetailPage'
  ).then((m) => ({ default: m.PlatformUsageDetailPage }))
);

export const SETTINGS_ROUTE_CONFIG: OneClickNavItem[] = [
  {
    id: 'dashboard',
    title: 'Overview',
    route: SETTINGS_ROUTE_SEGMENTS.dashboard,
    page: OrganizationDetailsPage,
    breadcrumbs: ['Overview'],
  },
  {
    id: 'platformUsageReportingPlans',
    title: 'Reporting plans',
    route: `${SETTINGS_ROUTE_SEGMENTS.billingReport}/reporting/plans`,
    page: ReportingPlansPage,
    breadcrumbs: ['Platform usage', 'Plans'],
    rules: [['view', 'OrganizationBillingReport']],
    routeOnly: true,
  },
  {
    id: 'platformUsageReporting',
    title: 'Reporting',
    route: `${SETTINGS_ROUTE_SEGMENTS.billingReport}/reporting`,
    page: ReportingPlatformUsagePage,
    breadcrumbs: ['Platform usage', 'Reporting'],
    rules: [['view', 'OrganizationBillingReport']],
    routeOnly: true,
  },
  {
    id: 'platformUsageDetail',
    title: 'Platform usage',
    route: `${SETTINGS_ROUTE_SEGMENTS.billingReport}/:feature`,
    page: PlatformUsageDetailPage,
    breadcrumbs: ['Platform usage'],
    rules: [['view', 'OrganizationBillingReport']],
    routeOnly: true,
  },
  {
    id: 'platformUsage',
    title: 'Platform usage',
    route: SETTINGS_ROUTE_SEGMENTS.billingReport,
    page: BillingPlatformUsagePage,
    breadcrumbs: ['Platform usage'],
    rules: [['view', 'OrganizationBillingReport']],
  },
  {
    id: 'clusterHibernation',
    title: 'Hibernation',
    route: SETTINGS_ROUTE_SEGMENTS.clusterHibernation,
    page: ClusterHibernationPage,
    breadcrumbs: ['Hibernation'],
    rules: [['view', 'OrganizationClusterHibernate']],
  },
  {
    id: 'scheduledRebalancing',
    title: 'Rebalancing',
    route: SETTINGS_ROUTE_SEGMENTS.scheduledRebalancing,
    page: ScheduledRebalancingPage,
    breadcrumbs: ['Rebalancing'],
    rules: [['view', 'OrganizationRebalanceSchedules']],
  },
  {
    id: 'commitments',
    title: 'Commitments',
    route: `${SETTINGS_ROUTE_SEGMENTS.commitments}/*`,
    page: CommitmentsController,
    breadcrumbs: ['Commitments'],
    rules: [['view', 'OrganizationCommitments']],
  },
  {
    title: 'System settings',
    route: '*',
    page: SystemController,
    breadcrumbs: ['Overview'],
    routeOnly: true,
  },
];
